const getLeads = state => state.lead.seekerLeads.leads;
const getLoading = state => state.lead.seekerLeads.loading;
const getPagingData = state => state.lead.seekerLeads.paging;
const getOrderSelector = state => state.lead.seekerLeads.sorted;
const getMobileLoader = state => state.lead.seekerLeads.updateMobile;
const getparams = state => state.lead.seekerLeads.params.offset;

export { getLeads, getLoading, getPagingData, getOrderSelector, getMobileLoader, getparams };
